<section
  class="rounded-xl border border-[rgba(255,125,125,0.35)] bg-[rgba(85,24,24,0.25)] px-5 py-6 text-center"
>
  <p class="m-0 text-sm font-semibold uppercase tracking-[0.12em] text-[rgba(255,178,178,0.9)]">
    Access Blocked
  </p>
  <p class="mt-3 text-4xl font-bold tabular-nums text-[#ffb3b3]">{{ countdownLabel() }}</p>
  <p class="mt-2 text-sm text-[rgba(255,178,178,0.8)]">
    Too many incorrect OTP attempts. Wait for the timer to finish.
  </p>

  <button
    type="button"
    class="mt-5 w-full rounded-lg border border-[#3f5168] bg-transparent px-4 py-2.5 text-sm font-semibold text-[#c7d5e4] transition hover:bg-[rgba(199,213,228,0.08)]"
    (click)="onBackToLogin()"
  >
    Back to Login
  </button>
</section>
